var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
export class ScrollSpy extends Component {
    constructor(menuElementName, sectionClass, headerHeight) {
        super('ScrollSpyComponent', false);
        this.menuElementName = menuElementName;
        this.sectionClass = sectionClass;
        this.headerHeight = headerHeight;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.links = $(this.menuElementName + ' a');
            this.sections = $(this.sectionClass);
            this.offset = ($(window).width() < 768) ? 80 + $('#left-menu').height() + 36 : this.headerHeight;
            $(window).on('resize', () => {
                this.offset = ($(window).width() < 768) ? 80 + $('#left-menu').height() + 36 : this.headerHeight;
            });
            $(window).on('scroll', () => {
                this.spy();
            });
            this.spy();
            this.links.on('click', (event) => {
                event.preventDefault();
                var target = $($(event.target).attr('href'));
                var top = (target.get(0) === this.sections.get(0)) ? 0 : target.position().y - this.offset + 10;
                $.scrollTo(top);
            });
            this.success();
        });
    }
    spy() {
        var currentID = '';
        this.sections.each((section) => {
            if (section.viewportPosition().y <= this.offset)
                currentID = $(section).attr('id');
        });
        if (currentID) {
            this.links.removeClass('color-black').addClass('color-gray').search('[href="#' + currentID + '"]').removeClass('color-gray').addClass('color-black');
        }
    }
}
